import { render } from "./SoftInput.vue?vue&type=template&id=f8ff758c"
import script from "./SoftInput.vue?vue&type=script&lang=js"
export * from "./SoftInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__